import {useFieldArray, useFormContext} from 'react-hook-form';
import {LocationFormField} from '../../types';
import {
  ErrorMessage,
  FormGroup,
  FormItemGroup,
  Input,
} from '@common/components/form-items';
import {IconButton} from '@common/components/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlusCircle} from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';
import IPAddressInfo from '../ip-address-info';
import {ReactComponent as TrashIcon} from '@gakki/assets/trash.svg';

const IPPattern =
  /^\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b$/;
const IPAddress = function () {
  const {
    register,
    control,
    formState: {errors},
  } = useFormContext<LocationFormField>();
  const {append, fields, remove} = useFieldArray({
    control,
    name: 'ipAddresses',
  });

  useEffect(() => {
    if (fields.length === 0) {
      append({value: ''})
    }
  }, [fields])
  return (
    <FormGroup columnTemplates={1}>
      <FormItemGroup>
        <label className={'flex gap-[15px]'}>
          <span>
            IP 位置
            <IPAddressInfo />
          </span>
          {fields.length === 0 && (
            <IconButton onClick={() => append({value: ''})}>
              <FontAwesomeIcon
                icon={faPlusCircle}
                style={{fontSize: 20, color: '#3e4348'}}
              />
            </IconButton>
          )}
        </label>
        {fields.map((field, idx) => {
          return (
            <div className={'mb-[10px]'} key={field.id}>
              <Input
                className={'!h-[26px] !w-[373px] align-middle mr-[9px]'}
                ref={register({pattern: IPPattern, required: true})}
                name={`ipAddresses.${idx}.value`}
                defaultValue={field.value}
                placeholder={'請輸入IP位置'}
                error={
                  errors?.ipAddresses &&
                  errors?.ipAddresses[idx]?.value &&
                  'IP格式錯誤'
                }
              />
              <div className={'inline-flex align-middle justify-between'}>
                <span className="inline-block w-[20px] mr-[9px]">
                  {fields.length > 1 && (
                    <IconButton
                      onClick={() => remove(idx)}
                      data-test-id={'remove-btn'}
                    >
                      <TrashIcon/>
                    </IconButton>
                  )}
                </span>
                <span className="inline-block w-[20px]">
                  {fields.length - 1 === idx && (
                    <IconButton onClick={() => append({value: ''})} data-test-id={'add-btn'}>
                      <FontAwesomeIcon
                        icon={faPlusCircle}
                        className={'text-xl'}
                        data-test-id={'add-btn'}
                      />
                    </IconButton>
                  )}
                </span>
              </div>
              <ErrorMessage>
                {errors?.ipAddresses &&
                  errors?.ipAddresses[idx]?.value &&
                  'IP格式錯誤'}
              </ErrorMessage>
            </div>
          );
        })}
      </FormItemGroup>
    </FormGroup>
  );
};

export default IPAddress;
